import styled from 'styled-components'

export const TextLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`
